(function () {
    'use strict';

    angular.module('app.blogPostTag', [
        // Angular modules
        'ngRoute',

        // Custom modules
        'treeControl'
        // 3rd Party Modules

    ]);
})();